var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrpUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9107 8.75C14.0443 8.75 14.9561 7.83 14.9561 6.69643C14.9561 5.56286 14.0443 4.64286 12.9107 4.64286C11.7771 4.64286 10.8571 5.56286 10.8571 6.69643C10.8571 7.83 11.7771 8.75 12.9107 8.75ZM6.75 7.92857C8.11357 7.92857 9.20607 6.82786 9.20607 5.46429C9.20607 4.10071 8.11357 3 6.75 3C5.38643 3 4.28571 4.10071 4.28571 5.46429C4.28571 6.82786 5.38643 7.92857 6.75 7.92857ZM12.9107 10.3929C11.4075 10.3929 8.39286 11.1486 8.39286 12.6518V13.6786C8.39286 14.1304 8.7625 14.5 9.21429 14.5H16.6071C17.0589 14.5 17.4286 14.1304 17.4286 13.6786V12.6518C17.4286 11.1486 14.4139 10.3929 12.9107 10.3929ZM6.75 9.57143C4.83607 9.57143 1 10.5325 1 12.4464V13.6786C1 14.1304 1.36964 14.5 1.82143 14.5H6.75V12.6518C6.75 11.9536 7.02107 10.7296 8.69679 9.80143C7.98214 9.65357 7.29214 9.57143 6.75 9.57143Z",
    fill: "#969698"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrpUsers);
export default __webpack_public_path__ + "static/media/grp-users.f04a874dbe187031ab8a757904b8022f.svg";
export { ForwardRef as ReactComponent };